export default __webpack_public_path__ + "static/media/UsdxxLogo.415dfab9.webp";